import { createAsyncThunk } from '@reduxjs/toolkit'
import Game from './game-model'
import { delete_game, load_games, store_game } from './game-service'

export const LoadGamesAsync = createAsyncThunk<any, any>(
  'composer/load/game',
  async (params: { uid: string }) => {
    return await load_games(params)
  },
)

export const CreateGameAsync = createAsyncThunk<any, any>(
  'composer/create/game',
  async (params: Game) => {
    return await store_game(params)
  },
)

export const DeleteGameAsync = createAsyncThunk<any, any>(
  'composer/delete/game',
  async (params) => {
    return await delete_game(params)
  },
)
